export const OPEN_MODAL  = '@maia/BookingActions/OPEN_MODAL';
export const CLOSE_MODAL  = '@maia/BookingActions/CLOSE_MODAL';
export const MODAL_BUSY  = '@maia/BookingActions/MODAL_BUSY';


export const MARK_WORK_COMPLETE  = '@maia/BookingActions/MARK_WORK_COMPLETE';
export const MARK_WORK_COMPLETE_SUCCESS  = '@maia/BookingActions/MARK_WORK_COMPLETE_SUCCESS';
export const MARK_WORK_COMPLETE_FAILURE  = '@maia/BookingActions/MARK_WORK_COMPLETE_FAILURE';

export const PATCH_BOOKING  = '@maia/BookingActions/PATCH_BOOKING';
export const CHARGE_PAYMENT = '@maia/BookingActions/CHARGE_PAYMENT';
export const ADD_NOTE = '@maia/BookingActions/ADD_NOTE';
